import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-data-error',
  standalone: true,
  imports: [MatIconModule, CommonModule],
  templateUrl: './data-error.component.html',
  styleUrl: './data-error.component.scss'
})
export class DataErrorComponent {

  @Input() message: string = 'No data found';
  @Input() icon: string = 'bar_chart';
  @Input() showText: boolean = true;
}
